type BrandLogoProps = {
  subtitle?: string;
};

export function BrandLogo({ subtitle }: BrandLogoProps) {
  return (
    <span className="brand-mark" aria-label="wypelnijpdf.pl">
      <span className="brand-icon" aria-hidden="true">
        <svg viewBox="0 0 56 56" role="img">
          <path className="brand-page" d="M15 7h18l8 8v34H15z" />
          <path className="brand-fold" d="M33 7v10h10" />
          <path className="brand-line brand-line-a" d="M21 25h18" />
          <path className="brand-line brand-line-b" d="M21 32h14" />
          <path className="brand-sign" d="M21 41c4-5 7 5 12-1 2-2 4-2 7-1" />
        </svg>
      </span>
      <span className="brand-copy">
        <strong>wypelnijpdf.pl</strong>
        {subtitle ? <small>{subtitle}</small> : null}
      </span>
    </span>
  );
}
